<template lang="pug">
v-container
  .middle 
    v-card.mx-auto.rounded-lg(max-width="100%", elevation="10")
      v-card-title {{ $t('documentation') }}
      v-card-text
        v-divider
        v-container          
          v-row(align="center", elevation="10", justify="space-around" style="height: 160px;")
            v-btn.nufi-btn(depressed @click="openLink('http://docs.nufi.mx')") 
              v-html {{ $t('techreference') }}
            v-btn.nufi-btn(depressed @click="openLink('http://guias.nufi.mx')")
              v-html {{ $t('implementationguides') }}            
</template>
<script>
import link from '@/mixins/link';

export default {
  mixins: [link],
}
</script>